"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var pdfWorkerFactory = function pdfWorkerFactory() {
  return new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();
};
var _default = exports["default"] = pdfWorkerFactory;